// The following rule is disabled because we are only importing the types
// eslint-disable-next-line import/no-extraneous-dependencies
import { FeatureCollection, Polygon } from '@nebula.gl/edit-modes';
import { BaseEvent, DrawPolygonMode, ModeProps } from 'react-map-gl-draw';

class CustomDrawPolygonMode extends DrawPolygonMode {
  _modeProps: ModeProps<FeatureCollection> | null = null;

  handleClick(event: BaseEvent, props: ModeProps<FeatureCollection>): void {
    this._modeProps = props;
    super.handleClick(event, props);
  }

  closePolygon(): void {
    if (!this._modeProps) {
      return;
    }

    const clickSequence = this.getClickSequence();

    if (clickSequence.length < 3) {
      return;
    }

    const polygonToAdd: Polygon = {
      type: 'Polygon',
      coordinates: [[...clickSequence, clickSequence[0]]],
    };

    this.resetClickSequence();

    const editAction = this.getAddFeatureAction(
      polygonToAdd,
      this._modeProps.data
    );

    if (editAction) {
      this._modeProps.onEdit(editAction);
    }
  }

  removeLastPoint(): void {
    this._clickSequence.pop();
  }
}

export default CustomDrawPolygonMode;
